const API_BASE = '/api';

function extractErrorMessage(data, status) {
  if (!data || typeof data !== 'object') {
    return `请求失败 (${status})`;
  }
  if (typeof data.error === 'string' && data.error) {
    return data.error;
  }
  const detail = data.detail;
  if (typeof detail === 'string' && detail) {
    return detail;
  }
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    if (typeof first === 'string') return first;
    if (first && typeof first.msg === 'string') return first.msg;
  }
  return `请求失败 (${status})`;
}

async function request(path, options = {}) {
  const { method = 'GET', body, headers, ...rest } = options;
  const response = await fetch(`${API_BASE}${path}`, {
    method,
    body,
    headers: { 'Content-Type': 'application/json', ...(headers || {}) },
    ...rest,
  });
  let data;
  try {
    data = await response.json();
  } catch {
    return { ok: false, error: `请求失败 (${response.status})` };
  }
  if (data.ok === false) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  if (!response.ok) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  return data;
}

function backendNotReadyMessage(status) {
  if (status === 404 || status === 405) {
    return '后端服务未加载领料单接口，请在 backend 目录重启：python -m uvicorn server:app --host 127.0.0.1 --port 8813 --reload';
  }
  return '';
}

async function uploadFile(path, file) {
  const safeName = (file?.name || '').trim() || 'upload.xlsx';
  const form = new FormData();
  form.append('file', file, safeName);
  form.append('original_name', safeName);
  let response;
  try {
    response = await fetch(`${API_BASE}${path}`, { method: 'POST', body: form });
  } catch {
    return { ok: false, error: '网络异常，上传失败' };
  }
  const raw = await response.text();
  let data;
  try {
    data = raw ? JSON.parse(raw) : {};
  } catch {
    const hint = backendNotReadyMessage(response.status);
    return { ok: false, error: hint || `上传失败 (${response.status})` };
  }
  if (data.ok === false) {
    return { ok: false, error: extractErrorMessage(data, response.status) };
  }
  if (!response.ok) {
    const hint = backendNotReadyMessage(response.status);
    return { ok: false, error: hint || extractErrorMessage(data, response.status) };
  }
  return data;
}

export const inventoryImportApi = {
  getState: () => request('/inventory/state'),
  uploadMe2l: (file) => uploadFile('/inventory/me2l/upload', file),
  uploadMb51: (file) => uploadFile('/inventory/mb51/upload', file),
  generateMe2l: () => request('/inventory/me2l/generate', { method: 'POST' }),
  generateMb51: () => request('/inventory/mb51/generate', { method: 'POST' }),
  clearMe2l: () => request('/inventory/reset', { method: 'POST', body: JSON.stringify({ scope: 'me2l' }) }),
  clearMb51: () => request('/inventory/reset', { method: 'POST', body: JSON.stringify({ scope: 'mb51' }) }),
  resetAll: () => request('/inventory/reset', { method: 'POST', body: JSON.stringify({ scope: 'all' }) }),
  downloadUrl: (filename) => `${API_BASE}/inventory/download/${encodeURIComponent(filename)}`,
};
